import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type PurchaseOrdering} from 'web-app/util/graphql/api-types';
import * as TypedActionCreators from 'web-app/util/redux/typed-action-helpers';

const domain = 'MODALS/PURCHASE';

export const {action: showPurchaseModal} = createAction(
    `${domain}/SHOW_PURCHASE_MODAL`,
    (childId: string, itemId?: string, ordering?: PurchaseOrdering) => ({childId, itemId, ordering}),
);

export const {action: hidePurchaseModal} = createAction(`${domain}/HIDE_PURCHASE_MODAL`, () => ({}));

export const {action: hidePurchaseModalAfterUpdate} = TypedActionCreators.createAction(
    'MODALS/PURCHASE/HIDE_PURCHASE_MODAL_AFTER_UPDATE',
    (oldPurchase: MadeAnyDuringTs45Update, newPurchase: MadeAnyDuringTs45Update) => ({
        oldPurchase,
        newPurchase,
    }),
);

export const {action: hidePurchaseModalAfterDelete} = TypedActionCreators.createAction(
    'MODALS/PURCHASE/HIDE_PURCHASE_MODAL_AFTER_DELETE',
    (oldPurchase: MadeAnyDuringTs45Update) => ({
        oldPurchase,
    }),
);

export const {action: onDateChange} = createAction(`${domain}/ON_DATE_CHANGE`, newDate => ({newDate}));

export const {action: showReject} = createAction(`${domain}/SHOW_REJECT`, show => ({show}));

export const {action: showOverridePrices} = createAction(`${domain}/SHOW_OVERRIDE_PRICES`, show => ({show}));
